import React from 'react';
import cn from 'classnames';
import { Link } from '@/Framework/Router/Next/Link';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import IconInfo from '@dealroadshow/uikit/core/components/Icon/IconInfo';
import IconExternalLink from '@dealroadshow/uikit/core/components/Icon/IconExternalLink';

import styles from '../styles.scss';
import { iconStyles } from '@dealroadshow/uikit/core/components/Icon';

interface IProps {
  cellData: string,
  row: {
    url?: string,
    info?: string,
  },
}

const LinkCell = ({
  cellData,
  row: {
    url,
    info,
  },
}: IProps) => {
  if (url) {
    return (
      <Link target="_blank" to={ url } className={ styles.linkCell }>
        <span className={ styles.linkCellText }>{ cellData }</span>
        <IconExternalLink className={ cn(styles.linkCellIcon, styles.linkIcon) } />
      </Link>
    );
  }

  if (info) {
    return (
      <div className={ styles.linkCell }>
        <span>{ cellData }</span>
        <Tooltip
          content={ info }
          containerClassName={ styles.infoIcon }
        >
          <IconInfo
            className={ cn(iconStyles.greyIcon, iconStyles.smallIcon) }
          />
        </Tooltip>
      </div>
    );
  }

  return <span className={ styles.linkCell }>{ cellData }</span>;
};

export default LinkCell;
